import { createSelector } from 'reselect'

const getFull = ({ funds }) => funds.list.full
const getTotal = ({ funds }) => funds.list.total
const getCurrent = (state, props) => props.id || null
export const getFunds = ({ funds }) => funds.list.items

export const getFundsList = createSelector(
  [ getFunds, getTotal ],
  (items = [], total = 0) => ({
    total,
    items,
    length: items.length
  })
)

export const getFullFundInfo = () => createSelector(
  [ getFull, getCurrent ],
  (items, current) => {
    return current ? (items[current] || null) : null
  }
)



// WEBPACK FOOTER //
// ./src/selectors/funds.js